import React, { useEffect } from 'react';
import InformationHeader from '../../../component/reusable/informationHeader/InformationHeader';
import { useDispatch, useSelector } from 'react-redux';
import { getCategoryHeirarchy } from '../../../redux/getCategoryHeirarchy';
import EditSubCategoryForm from '../../../component/subcategoryComps/EditSubCategoryForm';

const EditSubCategory = () => {
  const dispatch = useDispatch();
  const { categoryHeirarchy } = useSelector((state) => state.categoryHeirarchy);
  const categories = categoryHeirarchy?.categories
  useEffect(() => {
    dispatch(getCategoryHeirarchy());
  }, []);
  return (
    <div >
      <InformationHeader mainpage="Dashboard" prevpage="Categories"  pagename="Edit Category" buttonText="Update category"/>
      <EditSubCategoryForm categories={categories}/>
    </div>
  );
};

export default EditSubCategory;
